import React from "react";
import CustomTags from "../Core/Components/CustomTags";
import InfoCircleIcon from "../Common/Svgs/InfoCircleIcon";

const getTripStatus = (currentStatus, record) => {
  if (currentStatus === 3 && record?.receiptStatus === 0) {
    return (
      <CustomTags width="receiptPending" colors="alert" background="alert">
        <div className="relative group inline-block">
          <div className="flex items-center gap-x-2">
            <InfoCircleIcon size={16} className="text-alert" />
            <p>Completed</p>
          </div>

          <div
            className="
              absolute left-1/2 top-full mt-2 hidden group-hover:flex 
              -translate-x-1/2 px-2 py-1 rounded-4 bg-dark-gray 
              text-xs text-background font-aileron font-normal text-[10px] 
              w-max z-50 pointer-events-none
            "
          >
            <span>Receipt verification pending</span>

            <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-3 h-3 rotate-45 bg-dark-gray" />
          </div>
        </div>
      </CustomTags>
    );
  }
  switch (currentStatus) {
    case 1:
      return (
        <CustomTags colors="tripOngoing" background="tripOngoing">
          <div className="flex items-center gap-x-2">Ongoing</div>
        </CustomTags>
      );
    case 2:
      return (
        <CustomTags colors="checkIn" background="checkIn">
          <div className="flex items-center gap-x-2">Upcoming</div>
        </CustomTags>
      );
    case 3:
      return (
        <CustomTags colors="tripCompleted" background="tripCompleted">
          <div className="flex items-center gap-x-2">Completed</div>
        </CustomTags>
      );
    default:
      return (
        <CustomTags colors="tripOngoing" background="tripOngoing">
          <div className="flex items-center gap-x-2">Ongoing</div>
        </CustomTags>
      );
  }
};

export default getTripStatus;
